import { takeEvery, call, put } from 'redux-saga/effects'
import {
    REQUEST_FURNITURE_SAGA,
    REQUEST_FURNITURE_BY_IDS_SAGA,
    REQUEST_FURNITURE_BY_LOCALITEMNOS_SAGA,
    REQUEST_FURNITURE_CATEGORIES_SAGA,
    REQUEST_FURNITURE_SWAPPABLES_SAGA,
    REQUEST_FURNITURE_COMBINABLES_SAGA,
} from 'models/actionTypes'
import {
    getFurniture,
    getFurnitureBySearch,
    getFurnitureByIds,
    getFurnitureByLocalItemNos,
    getFurnitureCategories,
    getFurnitureSwappables,
    getFurnitureCombinables,
} from 'services/furniture'
import { LOCALE_US_EN } from 'models/location/constants'
import {
    receiveFurniture,
    failedReceiveFurniture,
    receiveFurnitureByIds,
    failedReceiveFurnitureByIds,
    receiveFurnitureByLocalItemNos,
    failedReceiveFurnitureByLocalItemNos,
    receiveFurnitureCategories,
    failedReceiveFurnitureCategories,
    receiveFurnitureSwappables,
    failedReceiveFurnitureSwappables,
    selectFurniture,
    receiveFurnitureCombinables,
    failedReceiveFurnitureCombinables,
} from './actions'

export function* requestFurnitureSaga({ filter, requestedPage, moreToken, debugModelUrl, debugFurnitureId }) {
    try {
        let furniture
        let count
        let hasNext
        let nextMoreToken

        if (filter.query) {
            const { data } = yield call(getFurnitureBySearch, filter, moreToken)
            furniture = data.results
            count = data.results.length
            hasNext = !!data.moreToken
            nextMoreToken = data.moreToken
        } else {
            const { data } = yield call(getFurniture, filter, requestedPage)
            furniture = data.results
            count = data.count
            hasNext = !!data.next
        }

        if (debugModelUrl) {
            const urlModel = {
                id: 1,
                localItemNumber: '1',
                name: 'Debug URL Model',
                region: LOCALE_US_EN,
                thumbUrl: `${ASSET_BUCKET}/logo_sugarcube_bug_ikea.svg`,
                modelUrl: debugModelUrl,
                rotX: 1.5707963267949,
                scale: 1,
                maxX: 0.361636996269226,
                maxY: 0.8396155834198,
                maxZ: 0.353101998567581,
                minX: -0.361636996269226,
                minY: 0,
                minZ: -0.353101998567581,
                stacks: false,
                isDebug: true,
                collections: ['Debug'],
                rootCategories: ['Debug'],
                categories: ['Debug'],
                subCategories: [],
                description: 'This model is loaded from a URL param',
                imageUrls: [`${ASSET_BUCKET}/logo_sugarcube_bug_ikea.svg`],
                availableInRegion: true,
                geometryType: '3d',
                price: '$4.19',
            }
            furniture.push(urlModel)
        }

        yield put(receiveFurniture(furniture, filter, count, hasNext, nextMoreToken))

        const selectDebugFurnitureId = debugModelUrl ? 1 : debugFurnitureId
        if (selectDebugFurnitureId) {
            yield call(selectFurniture(parseInt(selectDebugFurnitureId, 10)))
        }
    } catch (error) {
        yield put(failedReceiveFurniture())
    }
}

export function* requestFurnitureByIdsSaga({ ids }) {
    try {
        const { data: furniture } = yield call(getFurnitureByIds, ids)
        yield put(receiveFurnitureByIds(furniture))
    } catch (error) {
        yield put(failedReceiveFurnitureByIds())
    }
}

export function* requestFurnitureByLocalItemNosSaga({ localItemNos }) {
    try {
        const { data: furniture } = yield call(getFurnitureByLocalItemNos, localItemNos)
        yield put(receiveFurnitureByLocalItemNos(furniture))
    } catch (error) {
        yield put(failedReceiveFurnitureByLocalItemNos())
    }
}

export function* requestFurnitureCategoriesSaga({ region, stackEnabled }) {
    try {
        const { data: categories } = yield call(getFurnitureCategories, region, stackEnabled)
        yield put(receiveFurnitureCategories(categories))
    } catch (error) {
        yield put(failedReceiveFurnitureCategories())
    }
}

export function* requestFurnitureSwappablesSaga({ id }) {
    try {
        const { data: furniture } = yield call(getFurnitureSwappables, id)
        yield put(receiveFurnitureSwappables(furniture, id))
    } catch (error) {
        yield put(failedReceiveFurnitureSwappables())
    }
}

export function* requestFurnitureCombinablesSaga({ id, uniqueId, slotCategory, size, variant, nodeIndex }) {
    try {
        const { data: furniture } = yield call(getFurnitureCombinables, slotCategory, size, variant)
        yield put(receiveFurnitureCombinables(furniture, id, uniqueId, nodeIndex))
    } catch (error) {
        yield put(failedReceiveFurnitureCombinables())
    }
}

function* watchRequestFurnitureSaga() {
    yield takeEvery(REQUEST_FURNITURE_SAGA, requestFurnitureSaga)
}

function* watchRequestFurnitureByIdsSaga() {
    yield takeEvery(REQUEST_FURNITURE_BY_IDS_SAGA, requestFurnitureByIdsSaga)
}

function* watchRequestFurnitureByLocalItemNosSaga() {
    yield takeEvery(REQUEST_FURNITURE_BY_LOCALITEMNOS_SAGA, requestFurnitureByLocalItemNosSaga)
}

function* watchRequestFurnitureCategoriesSaga() {
    yield takeEvery(REQUEST_FURNITURE_CATEGORIES_SAGA, requestFurnitureCategoriesSaga)
}

function* watchRequestFurnitureSwappablesSaga() {
    yield takeEvery(REQUEST_FURNITURE_SWAPPABLES_SAGA, requestFurnitureSwappablesSaga)
}

function* watchRequestFurnitureCombinablesSaga() {
    yield takeEvery(REQUEST_FURNITURE_COMBINABLES_SAGA, requestFurnitureCombinablesSaga)
}

export const furnitureSagas = [
    watchRequestFurnitureSaga(),
    watchRequestFurnitureByIdsSaga(),
    watchRequestFurnitureByLocalItemNosSaga(),
    watchRequestFurnitureCategoriesSaga(),
    watchRequestFurnitureSwappablesSaga(),
    watchRequestFurnitureCombinablesSaga(),
]
